var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('main',{staticClass:"verify-link"},[_c('h1',{staticClass:"center"},[_vm._v(_vm._s(_vm.check_status(_vm.verify)))]),_c('router-link',{staticClass:"button bt--edit",attrs:{"to":"/"}},[_c('span',[_vm._v("HOME")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }